import React from 'react';

import Title from '../../title';
import Permission from '../../../functions/permission';
import ReadCookie from '../../../functions/readcookies';
import getFormatedDate from '../../../functions/date';

export default class DebitNotes extends React.Component {

    state = {
        fromDate: getFormatedDate(new Date(), 'fromDate'),
        toDate: getFormatedDate(new Date(), 'toDate'),
    }

    componentDidMount() {
        this.getPurchaseDetails();
    }

    getPurchaseDetails() {
        let context = this;
    }

    render() {
        return (
            <div>
                <Title title={'Debit Notes'} openDrawer={this.props.openDrawer} />

            </div>
        );
    }

}